<!-- The best seller with its price and one button, instead of a slideshow with a general slogan. -->
<section class="bg-gradient-to-b from-green-50 to-white pt-[9.5rem] lg:pt-56 pb-6 lg:pb-12 px-5">
    <div class="max-w-5xl mx-auto grid grid-cols-[40%_1fr] lg:grid-cols-2 gap-4 lg:gap-10 items-center">
        <a class="block" [routerLink]="productUrl" tabindex="-1" aria-hidden="true">
            <img class="w-full max-h-[34vh] lg:max-h-[60vh] object-contain"
                 [src]="product?.images?.[0] || fallbackImage"
                 [alt]="product?.name || 'Forever Aloe Vera Gel'"
                 width="800" height="800"
                 fetchpriority="high"
                 loading="eager">
        </a>
        <div class="text-left">
            <p class="text-xs lg:text-sm font-semibold uppercase tracking-wide text-primaryDark">Најпродаван производ</p>
            <p class="pt-1 text-xl lg:text-4xl font-bold leading-tight text-gray-900">{{ headline }}</p>
            @if (product) {
                <p class="pt-2 flex flex-wrap items-baseline gap-x-2">
                    <span class="text-2xl lg:text-3xl font-bold text-gray-900">{{ product.price }} ден.</span>
                    @if (product.discount && product.originalPrice > product.price) {
                        <span class="text-sm lg:text-lg text-gray-500 line-through">{{ product.originalPrice }} ден.</span>
                        <span class="rounded bg-red-600 px-1.5 text-xs lg:text-sm font-semibold text-white">&minus;{{ discountPercent }}%</span>
                    }
                </p>
            }
            <ul class="hidden sm:block list-none pl-0 pt-3 space-y-1 text-sm lg:text-base text-gray-700">
                <li><span class="text-primaryDark font-bold" aria-hidden="true">✓</span> Плаќање при достава</li>
                <li><span class="text-primaryDark font-bold" aria-hidden="true">✓</span> Бесплатна достава над {{ freeDeliveryThreshold }} ден.</li>
            </ul>
            <a class="mt-3 lg:mt-6 inline-block rounded bg-primaryDark px-5 lg:px-8 py-2.5 lg:py-3 text-center font-semibold text-white hover:bg-primaryDarker transition"
               [routerLink]="productUrl">Нарачај сега</a>
            <a class="mt-2 block text-sm text-primaryDark underline" routerLink="/shop">Сите производи</a>
        </div>
    </div>
</section>
